import Value from "../../models/Value";
import {
  faBuilding,
  faGraduationCap,
  faHandshake
} from "@fortawesome/free-solid-svg-icons";

const optimizeModalData: Value[] = [
  {
    icon: faBuilding,
    title: "Financé par l’entreprise",
    description:
      "Ce financement est pris en charge directement par votre entreprise, facilitant ainsi l’accès à la formation sans avance de frais."
  },
  {
    icon: faHandshake,
    title: "Financé par l’OPCO",
    description:
      "Depuis la réforme de la formation professionnelle, les entreprises cotisent à des OPCO (Opérateurs de Compétences). Ces organismes collectent ces fonds pour financer les formations des salariés selon des critères précis, permettant ainsi d’accompagner le développement des compétences en entreprise."
  },
  {
    icon: faGraduationCap,
    title: "Financé par le CPF (en cours d'obtention)",
    description:
      "Le Compte Personnel de Formation (CPF) est un dispositif qui permet à chaque salarié d’accumuler des heures de formation tout au long de sa carrière, mobilisables librement pour financer des formations qualifiantes ou certifiantes."
  }
];

export default optimizeModalData;
